import * as React from "react";
import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { IFormConfig } from "../Map/config";
import { Input } from "../Map/enums";
import { IFormData } from "./formFields";
import { InputField } from "./InputField";

export interface IFormProps {
    fieldConfig: IFormConfig;
    onChange: (data: IFormData) => void;
    validateForm: number;
    onFormValidated: (isValid: boolean) => void;
    resetForm: number;
    formValues?: IFormData;
}

export const Form = ({
    fieldConfig,
    onChange,
    validateForm,
    onFormValidated,
    resetForm,
    formValues
}: IFormProps): JSX.Element => {
    const [formData, setFormData] = useState({});
    const [validate, setValidate] = useState<number>(1);

    const formValidations = useRef({});

    // lauka redzamība, atkarībā no cita lauka vērtības
    const visibleFields = [...fieldConfig.fields].filter((field) => {
        let visible = !field.visibilityDeterminantField;
        if (formData[field.visibilityDeterminantField]) {
            visible = true;
            if (field.visibilityDeterminantFieldValue) {
                visible = formData[field.visibilityDeterminantField] === field.visibilityDeterminantFieldValue;
            }
        }
        return visible;
    });

    // lauka "required" vērtība, atkarībā no cita lauka vērtības
    visibleFields.map((field) => {
        let required = !!field.required;
        if (formData[field.requiredDeterminantField] && field.requiredDeterminantFieldValue) {
            required = formData[field.requiredDeterminantField] === field.requiredDeterminantFieldValue;
        }
        field.required = required;
    });

    const onChanged = (e: ChangeEvent<HTMLInputElement>) => {
        const data = { ...formData };
        data[e.target.name] = e.target.value;
        setFormData(data);
        onChange(data);
    };

    const onFieldValidated = useCallback(
        (name: string, isValid: boolean, i: number) => {
            if (!formValidations || !formValidations.current) {
                return;
            }
            const visibleFieldNames = fieldConfig.fields.filter((field) => {
                let visible = !field.visibilityDeterminantField;
                if (formData[field.visibilityDeterminantField]) {
                    visible = true;
                    if (field.visibilityDeterminantFieldValue) {
                        visible = formData[field.visibilityDeterminantField] === field.visibilityDeterminantFieldValue;
                    }
                }
                return visible;
            });
            const validations = { ...formValidations.current };
            validations[name] = isValid;

            const visibleFieldValidations = Object.keys(validations)
                .filter((key) => visibleFieldNames.find((field) => field.field === key))
                .reduce((obj, key) => {
                    obj[key] = validations[key];
                    return obj;
                }, {});

            formValidations.current = visibleFieldValidations;

            i + 1 === visibleFieldNames.length &&
                onFormValidated(!Object.values(formValidations.current).includes(false));
        },
        [formData]
    );

    useEffect(() => {
        setValidate(validateForm);
    }, [validateForm]);

    useEffect(() => {
        setFormData({});
    }, [resetForm]);

    useEffect(() => {
        if (formValues) {
            setFormData(formValues);
            onChange(formValues);
        }
    }, [formValues]);

    return (
        <form className="form-section">
            {visibleFields.map((field, i) =>
                field.type === Input.Label ? (
                    <div className="form-label" key={field.title + i}>
                        {field.title}
                    </div>
                ) : (
                    <InputField
                        config={field}
                        onChange={onChanged}
                        validate={validate}
                        onValidate={(isValid) => onFieldValidated(field.field, isValid, i)}
                        value={(formData && formData[field.field]) || ""}
                        key={field.title + i}
                    ></InputField>
                )
            )}
        </form>
    );
};
